// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + (chunkId === "1850" ? "monaco-editor" : chunkId) + "." + {"1850": "e56fa031","3529": "5ac588ef","4146": "a68ba55b","6859": "aa5cdbad","7472": "95fe9399",}[chunkId] + ".css"
}